"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=true;exports.default=void 0;var _index=_interopRequireDefault(require("@fusioncharts/charts/src/dataset/column/index.animation"));var _default={"initial.dataset.dragColumn":_index.default["initial.dataset.column"]};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/powercharts/src/dataset/dragcolumn/index.animation.js
// module id = ovqa
// module chunks = 5